import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "last:mb-x4 mt-x2"
}

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import PdfLinkDownload from '@/shared/navigation/pdf-link/PdfLinkDownload.vue';
import useProductSpecificationsData from '@/shared/product/details/ui/product-specifications/useProductSpecificationsData';
import TransparencyList from '@/shared/product/details/ui/product-specifications/TransparencyList.vue';
import useProductSpecificationsTile
    from '@/shared/product/details/ui/product-specifications/useProductSpecificationsTile';
import CO2EmissionsLogo from '../../emissions/CO2EmissionsLogo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClimateEmissionsList',
  setup(__props) {

const { climateEmissionsCollection } = useProductSpecificationsData();
const { transparencyReadMoreLinks } = useProductSpecificationsTile();
const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TransparencyList, {
    title: _unref(labels).climateFootprintTitle,
    "read-more-label": _unref(labels).readMoreAboutClimateFootprintLabel,
    "read-more-link": _unref(transparencyReadMoreLinks).readMoreAboutClimateFootprintLink
  }, {
    titleIcon: _withCtx(() => [
      _createVNode(CO2EmissionsLogo, { class: "h-16 mr-2" })
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(climateEmissionsCollection).climateEmissions, (emission) => {
        return (_openBlock(), _createElementBlock("li", {
          key: emission.emissionValue + emission.screeningSpecification,
          class: "last:mb-x4"
        }, [
          _createElementVNode("p", null, _toDisplayString(emission.emissionValue) + " " + _toDisplayString(emission.screeningSpecification), 1)
        ]))
      }), 128)),
      (_unref(climateEmissionsCollection).documentationUrl)
        ? (_openBlock(), _createBlock(PdfLinkDownload, {
            key: 0,
            class: "mt-x2",
            label: _unref(labels).transparencyDocumentationDownload,
            "is-direct-link": true,
            url: _unref(climateEmissionsCollection).documentationUrl
          }, null, 8, ["label", "url"]))
        : _createCommentVNode("", true),
      (_unref(climateEmissionsCollection).totalEmissionDescription)
        ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
            _createElementVNode("p", null, _toDisplayString(_unref(climateEmissionsCollection).totalEmissionDescription), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "read-more-label", "read-more-link"]))
}
}

})